import { mergeStyleSets } from '@uifabric/merge-styles';
import get from 'lodash/get';
import { pxToRem } from '../../utils';
import theme from '../../theme.style';

export default mergeStyleSets({
  driModuleForm: {
    '.calender-picker': {
      marginLeft: pxToRem(0),
      marginTop: pxToRem(0),
    },
    label: {
      fontSize: get(theme, 'fonts.medium.fontSize'),
      lineHeight: get(theme, 'fonts.medium.lineHeight'),
      fontWeight: get(theme, 'fonts.medium.fontWeight'),
      fontFamily: get(theme, 'fonts.medium.fontFamily'),
      marginTop: pxToRem(5),
      marginBottom: pxToRem(2),
      paddingTop: pxToRem(0),
      paddingBottom: pxToRem(0),
    },
  },
  dateField: {
    marginTop: pxToRem(10),
    maxWidth: pxToRem(400),
    input: {
      backgroundColor: 'white',
    },
  },
  fieldLabel: {
    fontSize: get(theme, 'fonts.medium.fontSize'),
    lineHeight: get(theme, 'fonts.medium.lineHeight'),
    fontWeight: get(theme, 'fonts.medium.fontWeight'),
    fontFamily: get(theme, 'fonts.medium.fontFamily'),
    display: 'block',
    marginBottom: pxToRem(6),
    paddingTop: pxToRem(0),
  },
  submitButton: {
    marginTop: '40px',
  },
  messageBar: {
    marginTop: pxToRem(5),
  },
  textField: {
    marginTop: pxToRem(10),
    maxWidth: pxToRem(500),
  },
  textInput: {
    backgroundColor: 'white',
  },
});
